import { createSlice, PayloadAction } from '@reduxjs/toolkit'; // Adjust the import path
import { ECommonDialogType } from '../../data/Constants';

import type { IDialogState } from '../../../types';

const initialState: IDialogState = {
  show: false,
  type: ECommonDialogType.Unknown,
  data: null,
  title: '',
  handleClickOk: () => {},
};

const DialogSlice = createSlice({
  name: 'dialog',
  initialState,
  reducers: {
    openDialog(state, action: PayloadAction<Partial<IDialogState>>) {
      return {
        ...state,
        ...action.payload,
        show: true,
      };
    },

    closeDialog() {
      return initialState;
    },
  },
});

export const { openDialog, closeDialog } = DialogSlice.actions;

export default DialogSlice.reducer;
